export const calculatePriceCeramic = (basePrice, activeProduct) => {
  const { ceramic } = basePrice;
  const { dims } = activeProduct;
  let totalSq = 0;
  let edge = 0;
  let cnc = 0;
  if (activeProduct.oblik == "Krug") {
    const diameter = parseInt(dims.diameter.value) / 100;
    totalSq = diameter * diameter;
    edge = diameter * 3.14;
    cnc =
      ceramic.cnc_threshold > diameter
        ? parseInt(ceramic.cnc_max)
        : parseInt(ceramic.cnc_min);
  } else {
    const width = parseInt(dims.width.value) / 100;
    const length = parseInt(dims.length.value) / 100;
    totalSq = width * length;
    edge = (width + length) * 2;
  }

  const processing = parseFloat(ceramic.obrada) * edge;
  const color = totalSq * parseFloat(ceramic.color);
  const mdf = totalSq * parseFloat(ceramic.mdf);
  const price = parseFloat(ceramic.price) * totalSq;

  const total = processing + price + color + mdf + cnc;

  return parseInt(total);
};

export const calculatePriceWood = (activeProduct, thickness, base) => {
  let width = 0;
  let length = 0;
  if (activeProduct.oblik == "Krug") {
    width = parseInt(activeProduct.dims.diameter.value) / 100;
    length = parseInt(activeProduct.dims.diameter.value) / 100;
  } else {
    width = parseInt(activeProduct.dims.width.value) / 100;
    length = parseInt(activeProduct.dims.length.value) / 100;
  }

  const totalSq = width * length;
  let price = 0;
  let processing = 0;
  const thicknessFormat = parseFloat(thickness.name);

  if (length >= base.drvo.price_threshold) {
    processing = base.drvo.obrada_cena_max;
    switch (activeProduct.board["Vrsta drveta"]) {
      case "Hrast": {
        price = base.drvo.hrast[`price_${thicknessFormat}_max`];
        break;
      }
      case "Orah": {
        price = base.drvo.orah[`price_${thicknessFormat}_max`];
        break;
      }
      case "Jasen": {
        price = base.drvo.jasen[`price_${thicknessFormat}_max`];
        break;
      }
    }
  } else {
    processing = base.drvo.obrada_cena_min;
    switch (activeProduct.board["Vrsta drveta"]) {
      case "Hrast": {
        price = base.drvo.hrast[`price_${thicknessFormat}_min`];
        break;
      }
      case "Orah": {
        price = base.drvo.orah[`price_${thicknessFormat}_min`];
        break;
      }
      case "Jasen": {
        price = base.drvo.jasen[`price_${thicknessFormat}_min`];
        break;
      }
    }
  }
  const thicknessRaw = parseFloat(thickness.raw);
  const total =
    totalSq * thicknessRaw * 1.2 * parseInt(price) * parseFloat(processing);

  return parseInt(total);
};

export const calculatePriceLegs = (model) => {
  const { matchedDimsPrice, matchedMaterialPrice } = model;

  return matchedDimsPrice
    ? parseInt(matchedDimsPrice)
    : 0 + matchedMaterialPrice
    ? parseInt(matchedMaterialPrice)
    : 0;
};

export const calculateEdgePrice = (activeProduct, basePrice) => {
  const { dims } = activeProduct;
  const { edge } = basePrice;
  if (activeProduct.oblik == "Krug") {
    const diameter = parseInt(dims.diameter.value) / 100;
    const edgeLength = diameter * 2 * 3.14;
    const coef =
      edgeLength > edge.circle_threshold
        ? edge.circle_max_price
        : edge.circle_min_price;
    return edgeLength * parseFloat(coef);
  } else {
    const width = parseInt(dims.width.value) / 100;
    const length = parseInt(dims.length.value) / 100;
    const edgeLength = (width + length) * 2;
    const coef = edgeLength > edge.threshold ? edge.max_price : edge.min_price;
    return edgeLength * parseFloat(coef);
  }
};

export const getShapePrice = (activeProduct, basePrice) => {
  const { dims } = activeProduct;
  const { shape } = basePrice;
  let width = 0;
  let length = 0;
  if (activeProduct.oblik == "Krug") {
    width = parseInt(dims.diameter.value) / 100;
    length = parseInt(dims.diameter.value) / 100;
  } else {
    width = parseInt(dims.width.value) / 100;
    length = parseInt(dims.length.value) / 100;
  }
  const edgeLength = (width + length) * 2;
  return edgeLength > shape.threshold
    ? parseFloat(shape.max_price)
    : parseFloat(shape.min_price);
};
